import { DataLoader } from 'src/app/services/data-loader/data-loader';
import { XYChartAxis } from 'src/app/utils/echarts/xy-chart-axis';

export const createCase11 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const data = [
            {
                datetime: '2026-04-14T00:00:00.000Z',
                PurchaseComplete_count: 429,
            },
            {
                datetime: '2026-04-14T01:00:00.000Z',
                PurchaseComplete_count: 406,
            },
            {
                datetime: '2026-04-14T02:00:00.000Z',
                PurchaseComplete_count: 401,
            },
            {
                datetime: '2026-04-14T03:00:00.000Z',
                PurchaseComplete_count: 372,
            },
            {
                datetime: '2026-04-14T04:00:00.000Z',
                PurchaseComplete_count: 268,
            },
            {
                datetime: '2026-04-14T05:00:00.000Z',
                PurchaseComplete_count: 276,
            },
            {
                datetime: '2026-04-14T06:00:00.000Z',
                PurchaseComplete_count: 265,
            },
            {
                datetime: '2026-04-14T07:00:00.000Z',
                PurchaseComplete_count: 298,
            },
            {
                datetime: '2026-04-14T08:00:00.000Z',
                PurchaseComplete_count: 313,
            },
            {
                datetime: '2026-04-14T09:00:00.000Z',
                PurchaseComplete_count: 378,
            },
            {
                datetime: '2026-04-14T10:00:00.000Z',
                PurchaseComplete_count: 363,
            },
            {
                datetime: '2026-04-14T11:00:00.000Z',
                PurchaseComplete_count: 445,
            },
            {
                datetime: '2026-04-14T12:00:00.000Z',
                PurchaseComplete_count: 451,
            },
            {
                datetime: '2026-04-15T00:00:00.000Z',
                PurchaseComplete_count: 427,
            },
            {
                datetime: '2026-04-15T01:00:00.000Z',
                PurchaseComplete_count: 423,
            },
            {
                datetime: '2026-04-15T02:00:00.000Z',
                PurchaseComplete_count: 448,
            },
            {
                datetime: '2026-04-15T03:00:00.000Z',
                PurchaseComplete_count: 336,
            },
            {
                datetime: '2026-04-15T04:00:00.000Z',
                PurchaseComplete_count: 335,
            },
            {
                datetime: '2026-04-15T05:00:00.000Z',
                PurchaseComplete_count: 284,
            },
            {
                datetime: '2026-04-15T06:00:00.000Z',
                PurchaseComplete_count: 277,
            },
            {
                datetime: '2026-04-15T07:00:00.000Z',
                PurchaseComplete_count: 316,
            },
            {
                datetime: '2026-04-15T08:00:00.000Z',
                PurchaseComplete_count: 310,
            },
            {
                datetime: '2026-04-15T09:00:00.000Z',
                PurchaseComplete_count: 342,
            },
            {
                datetime: '2026-04-15T10:00:00.000Z',
                PurchaseComplete_count: 378,
            },
            {
                datetime: '2026-04-15T11:00:00.000Z',
                PurchaseComplete_count: 419,
            },
            {
                datetime: '2026-04-15T12:00:00.000Z',
                PurchaseComplete_count: 399,
            },
            {
                datetime: '2026-04-16T00:00:00.000Z',
                PurchaseComplete_count: 451,
            },
            {
                datetime: '2026-04-16T01:00:00.000Z',
                PurchaseComplete_count: 442,
            },
            {
                datetime: '2026-04-16T02:00:00.000Z',
                PurchaseComplete_count: 421,
            },
            {
                datetime: '2026-04-16T03:00:00.000Z',
                PurchaseComplete_count: 379,
            },
            {
                datetime: '2026-04-16T04:00:00.000Z',
                PurchaseComplete_count: 356,
            },
            {
                datetime: '2026-04-16T05:00:00.000Z',
                PurchaseComplete_count: 344,
            },
            {
                datetime: '2026-04-16T06:00:00.000Z',
                PurchaseComplete_count: 302,
            },
            {
                datetime: '2026-04-16T07:00:00.000Z',
                PurchaseComplete_count: 300,
            },
            {
                datetime: '2026-04-16T08:00:00.000Z',
                PurchaseComplete_count: 319,
            },
            {
                datetime: '2026-04-16T09:00:00.000Z',
                PurchaseComplete_count: 311,
            },
            {
                datetime: '2026-04-16T10:00:00.000Z',
                PurchaseComplete_count: 379,
            },
            {
                datetime: '2026-04-16T11:00:00.000Z',
                PurchaseComplete_count: 384,
            },
            {
                datetime: '2026-04-16T12:00:00.000Z',
                PurchaseComplete_count: 423,
            },
        ];

        queryContext.settings.datetimeAggregation = 'hour';

        XYChartAxis.fillMissingTimeGapRows(
            data,
            queryContext,
            'datetime',
            'hour'
        );

        this.emitter.emit({
            data,
            queryContext: queryContext,
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
